<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'accept'">Duyệt phản ánh</span>
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="3">
              <el-form-item label="Tên người đăng" prop="ho_ten">
                <el-input
                  v-model="mData.dataFormKDL.ho_ten.ho_ten"
                  :disabled="mData.viewMode == 'accept'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Email" prop="email">
                <el-input
                  v-model="mData.dataFormKDL.email"
                  :disabled="mData.viewMode == 'accept'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Số điện thoại" prop="dien_thoai">
                <el-input
                  v-model="mData.dataFormKDL.dien_thoai"
                  :disabled="mData.viewMode == 'accept'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="3">
              <el-form-item label="Giới tính" prop="gioi_tinh">
                <el-select
                  v-model="mData.dataFormKDL.gioi_tinh"
                  :placeholder="aLang.c_select"
                  :disabled="mData.viewMode == 'accept'"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="item in mData.dataDefault.listGioiTinh"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Địa chỉ" prop="dia_chi.dia_chi">
                <el-input
                  type="text"
                  v-model="mData.dataFormKDL.dia_chi.dia_chi"
                  :disabled="mData.viewMode == 'detail'"
                  clearable
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="Nội dung" prop="noi_dung">
                <CknoimgComponent
                  v-model="mData.dataForm.noi_dung"
                  :prop-data-editor-disabled="mData.viewMode == 'accept'"
                  @blur="handleBlur('noi_dung')"
                ></CknoimgComponent>
              </el-form-item>
            </b-col>
          </b-row>
          <el-form-item class="text-center mt-3">
            <el-button
              type="danger"
              plain
              @click="fn_submitForm('not-accept')"
              v-ladda
              v-if="mData.viewMode == 'accept'"
              >Từ chối</el-button
            >

            <el-button
              type="success"
              plain
              @click="fn_submitForm('accept')"
              v-ladda
              v-if="mData.viewMode == 'accept'"
              >Duyệt</el-button
            >

            <el-button @click="fn_go()" type="info" plain>{{
              aLang.c_back
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import PhanHoiModel from "./PhanHoiModel";
import KhachDuLichModel from "@/views/admin/KhachDuLich/KhachDuLichModel";
import mushroom from "../../../service/api/dulich-api";
import ExtensionService from "../../../service/ExtensionService";
import CknoimgComponent from "../../../component/CknoimgComponent";
import DataService from "@/service/DataService";
export default {
  components: {
    CknoimgComponent,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      aElement: MethodService.element,
      mData: {
        viewMode: "create",
        moduleName: "PhanHoi",
        dataDefault: {
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
          listGioiTinh: DataService.gioiTinh,
        },
        dataForm: MethodService.copyObject(PhanHoiModel.dataForm),
        dataFormKDL: MethodService.copyObject(KhachDuLichModel.dataForm),
        fileUploadOption: MethodService.copyObject(
          PhanHoiModel.dataFormOther.fileUploadOption
        ),
      },
    };
  },
  created() {
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-accept"
    ) {
      this.mData.viewMode = "accept";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = MethodService.copyObject(this.mData.dataForm);
          if (type === "accept") {
            data.trang_thai = 0;
            await mushroom.phan_hoi.partialUpdateAsync(data);
            this.fn_go();
          }
          if (type === "not-accept") {
            data.trang_thai = 2;
            await mushroom.phan_hoi.partialUpdateAsync(data);
            this.fn_go();
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    fn_resetForm() {
      this.mData.dataForm = MethodService.copyObject(PhanHoiModel.dataForm);

      this.$refs["myForm"].resetFields();
    },

    async fn_getDataById(id) {
      let tin_tuc = await mushroom.phan_hoi.findByIdAsync({ id: id });
      if (tin_tuc.result) {
        this.mData.dataForm = tin_tuc.result;
        if (tin_tuc.result.mediaId) {
          let data = {
            id: tin_tuc.result.mediaId,
            name: tin_tuc.result.mediaId,
            url: ExtensionService.urlImg + tin_tuc.result.mediaId,
          };
          this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
        }
      }

      let tt_kdl = await mushroom.khach_du_lich.findByIdAsync({
        id: this.mData.dataForm.user_id,
      });
      if (tt_kdl.result) {
        this.mData.dataFormKDL = tt_kdl.result;
      }
    },

    fn_go() {
      this.$router.go(-1);
    },

    fn_uploadRemoveAnhDaiDien() {
      this.mData.dataForm.mediaId = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "tinTuc")
        .then((res) => {
          this.mData.dataForm.mediaId = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch(() => {
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien() {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
    handleBlur(prop) {
      this.$refs["myForm"].validateField(prop);
    },
  },
};
</script>
